import { Alert } from '@components/display/alerts';
import { AlertTitle } from '@mui/material';

export interface IWarningToastProps {
    title?: string;
    msg?: string | string[];
}

export const WarningAlertToast = ({ msg, title = 'WARNING' }: IWarningToastProps) => (
    <Alert.Warning noStyle>
        <AlertTitle>{title}</AlertTitle>
        {msg}
    </Alert.Warning>
);
